import { AssessmentComponent, AssessmentStateEntry } from "@pandas/assessment-engine";
import type { Identification } from "@pandas/http-client";
import { mapAssessmentResults } from "@/lib/assessments/assessmentResultsMappings";
import { platformApi } from "@/services";
import { useLocalStorageStore } from "@/store";

export const handleDeviceDetails = async (identificationDetails: Identification | null | undefined) => {
	if (!identificationDetails) return;
	const setDeviceInfo = useLocalStorageStore.getState().setDeviceInfo;
	const rawMeta = identificationDetails.metadata;
	if (!rawMeta) return;
	// getSessionById stringifies metadata; continueEvaluation returns it parsed
	const meta = typeof rawMeta === "string" ? (JSON.parse(rawMeta) as Record<string, unknown>) : rawMeta;
	setDeviceInfo({
		imei: identificationDetails.identifier,
		brand: meta.brand as string | undefined,
		model: meta.model as string | undefined,
		capacity: (meta.capacity as string | undefined) ?? "",
		color: (meta.color as string | undefined) ?? "",
		memory: null,
	});
};

export const handleAssessmentDetailsByIdentifier = async (
	partnerId: string,
	identifier: string,
	configFunctionalAssessments: Array<AssessmentComponent>,
): Promise<{ timestamp: Date | null; functionalResults: Array<AssessmentStateEntry> }> => {
	const setFunctionalTestsUpdatedTimestamp = useLocalStorageStore.getState().setFunctionalTestsUpdatedTimestamp;
	if (identifier) {
		const assessmentsByIdentifier = await platformApi.getAssessmentsByIdentifier(identifier, partnerId);
		if (assessmentsByIdentifier?.Assessment) {
			const functionalResults = mapAssessmentResults(assessmentsByIdentifier.Assessment, "functional");
			const filteredFunctionalResults = functionalResults.filter((item) =>
				configFunctionalAssessments.includes(item.assessmentKey),
			);
			const hasFunctional = filteredFunctionalResults.length > 0;
			if (hasFunctional) setFunctionalTestsUpdatedTimestamp(new Date(Date.parse(assessmentsByIdentifier.updated_at)));
			return {
				timestamp: hasFunctional ? new Date(Date.parse(assessmentsByIdentifier.updated_at)) : null,
				functionalResults: filteredFunctionalResults,
			};
		}
	}
	return { timestamp: null, functionalResults: [] };
};
